module.exports = __webpack_public_path__ + "static/media/monteur_comes.ad82f8d7.png";